import React from "react"
import { useRouter } from "next/router"

import { handleFormSubmission } from "@utils/api/support"
import { ContactAndSupportDataProps } from "@utils/api"
import { RES_SUCCESS, FORM_SUCCESS_ROUTE, ERROR_MESSAGE } from "@constants/api"

import SupportRequest from "@components/form/forms/SupportRequest"

interface ISupportRequestForm {
  subjectOptions: string[]
  contactEmail: string
}

const SupportRequestForm: React.FC<ISupportRequestForm> = ({
  subjectOptions,
  contactEmail,
}) => {
  const [errorState, setErrorState] = React.useState(false)
  const [isFetchingData, setIsFetchingData] = React.useState(false)
  const router = useRouter()

  const onFormSubmit = async (data: ContactAndSupportDataProps) => {
    setIsFetchingData(true)
    const res: any = await handleFormSubmission(data, contactEmail)
    setIsFetchingData(false)
    if (res.status === RES_SUCCESS) {
      router.push(FORM_SUCCESS_ROUTE)
    } else {
      setErrorState(true)
    }
  }

  return (
    <SupportRequest
      subjectOptions={subjectOptions}
      onSubmit={(data: ContactAndSupportDataProps) => onFormSubmit(data)}
      errorMessage={errorState ? ERROR_MESSAGE : undefined}
      isLoading={isFetchingData}
    />
  )
}

export default SupportRequestForm
